const parseResponse = async <T>(response: Response): Promise<T> => {
  const data = (await response.json().catch(() => ({}))) as Record<string, unknown>;
  if (!response.ok) {
    throw new Error(String(data.error || "Não foi possível concluir a solicitação."));
  }
  return data as T;
};

export const api = {
  get: <T>(path: string) =>
    fetch(path, { credentials: "include" }).then((response) => parseResponse<T>(response)),

  post: <T>(path: string, body?: unknown) =>
    fetch(path, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: body === undefined ? undefined : JSON.stringify(body)
    }).then((response) => parseResponse<T>(response)),

  put: <T>(path: string, body: unknown) =>
    fetch(path, {
      method: "PUT",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    }).then((response) => parseResponse<T>(response)),

  patch: <T>(path: string, body: unknown) =>
    fetch(path, {
      method: "PATCH",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    }).then((response) => parseResponse<T>(response)),

  delete: <T>(path: string) =>
    fetch(path, { method: "DELETE", credentials: "include" }).then((response) =>
      parseResponse<T>(response)
    ),

  upload: <T>(path: string, file: File) => {
    const body = new FormData();
    body.append("file", file);
    return fetch(path, { method: "POST", credentials: "include", body }).then((response) =>
      parseResponse<T>(response)
    );
  }
};

export const money = (cents: number) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(cents / 100);

export const track = (type: "pageview" | "click", path: string, label?: string) => {
  try {
    const body = JSON.stringify({ type, path, label, referrer: document.referrer || undefined });
    if (navigator.sendBeacon) {
      navigator.sendBeacon("/api/track", new Blob([body], { type: "application/json" }));
    } else {
      fetch("/api/track", { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
    }
  } catch {
    /* tracking nunca deve quebrar a navegação */
  }
};
